import React, { useState } from "react";
import {
  Portal,
  useDisclosure,
  Stack,
  Box,
  useColorMode,
} from "@chakra-ui/react";
import Configurator from "components/Configurator/Configurator";
import Footer from "components/Footer/Footer.js";
import {
  ArgonLogoDark,
  ArgonLogoLight,
  ChakraLogoDark,
  ChakraLogoLight,
} from "components/Icons/Icons";
import Dashboard from "views/Dashboard/Dashboard.jsx";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import routes from "routes.js";
import MainPanel from "components/Layout/MainPanel";
import PanelContainer from "components/Layout/PanelContainer";
import PanelContent from "components/Layout/PanelContent";
import FixedPlugin from "components/FixedPlugin/FixedPlugin";
import { useEffect } from "react";

import componentMap from "routes/componentMap";   
import { getMenuFromStorage } from "../components/Sidebar/Sidebar";
import { TbRobotFace } from "react-icons/tb";

const getAllMenuRoutes = (apiMenu = []) => {
  const flatRoutes = [];

  apiMenu.forEach((item) => {
    // If it has subMenu (children)
    if (item.mainMenuId && item.subMenuName) {
      flatRoutes.push({
        path: item.routingPath,
        component: componentMap[item.routingPath] || componentMap.default,
      });
    }
  });

  return flatRoutes;
};

const getRoleFromUsername = (username) => {
  switch (username) {
    case "user-admin":
      return "ITUSER";
    case "user-orgi":
      return "ORGIUSER";
    case "user-cocacola":
      return "CocaColaUSER";
    default:
      return null;
  }
};

export default function AdminLayout(props) {
  const { ...rest } = props;
  const [fixed, setFixed] = useState(false);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const { colorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const userName = localStorage.getItem("userName") || sessionStorage.getItem("userName");
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

    if (!token) {
      history.push("/auth/signin");
    }
  }, [history])

  let defaultRoute = "/admin/dashboard"
  if (userName === "user-cocacola") {
    defaultRoute = "/admin/visicoolerImage";
  }
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse || routes[i].category) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category || routes[i].collapse) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };

  // const getRoutes = (routes) => {
  //   return routes.flatMap((prop, key) => {
  //     if (prop.collapse || prop.category) {
  //       return getRoutes(prop.views);
  //     }
  //     if (prop.layout === "/admin") {
  //       return (
  //         <Route
  //           exact
  //           path={prop.layout + prop.path}
  //           component={prop.component}
  //           key={key}
  //         />
  //       );
  //     }
  //     return null;
  //   });
  // };

  const getDynamicRoutes = () => {
  const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  const userName = localStorage.getItem("userName") || sessionStorage.getItem("userName");
  const userRole = getRoleFromUsername(userName);

  const apiMenu = getMenuFromStorage();   // reuse the same function from Sidebar

  const flatMenu = getAllMenuRoutes(apiMenu);

  return flatMenu.map((route, key) => {
    // Optional: Add role check if backend sends role info
    if (!token) {
      return null;
    }

    const Component = route.component;

    return (
      <Route
        key={key}
        exact
        path={`/admin${route.path}`}
        render={(props) => <Component {...props} />}
      />
    );
  });
};

  document.documentElement.dir = "ltr";

  return (
    <Box>
      <Box
        minH="20vh"
        w="100%"
        position="absolute"
        bg={colorMode === "light" ? "white" : "gray.800"}
        bgSize="cover"
        top="0"
      />
      <Sidebar
        routes={routes}
        onMinimizeChange={setIsSidebarMinimized}
        logo={
          <Stack direction="row" spacing="12px" align="center" justify="center">
            {colorMode === "dark" ? (
              <ArgonLogoLight w="74px" h="27px" />
            ) : (
              <ArgonLogoDark w="74px" h="27px" />
            )}
            <Box
              w="1px"
              h="20px"
              bg={colorMode === "dark" ? "white" : "gray.700"}
            />
            {colorMode === "dark" ? (
              <ChakraLogoLight w="82px" h="21px" />
            ) : (
              <ChakraLogoDark w="82px" h="21px" />
            )}
          </Stack>
        }
        display="none"
        {...rest}
      />
      <MainPanel
        ml={{ base: 0, lg: isSidebarMinimized ? "76px" : "296px" }}
        w={{
          base: "100%",
          lg: `calc(100% - ${isSidebarMinimized ? "76px" : "296px"})`,
        }}
        transition="all 0.3s ease-in-out"
      >
        <Portal>
          <AdminNavbar
            onOpen={onOpen}
            brandText={getActiveRoute(routes)}
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            isSidebarMinimized={isSidebarMinimized}
            {...rest}
          />
        </Portal>
        {getRoute() ? (
          <PanelContent>
            <PanelContainer className="dashboard-panel">
              <Switch>
  {getDynamicRoutes()}

  <Route exact path="/admin">
    <Redirect to={defaultRoute} />
  </Route>

  <Route path="/admin/dashboard">
    <Dashboard />
  </Route>
</Switch>

            </PanelContainer>
          </PanelContent>
        ) : null}
        <Footer />
        {/* <Portal>
          <FixedPlugin
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            onOpen={onOpen}
          />
        </Portal> */}
        {/* <Configurator
          secondary={getActiveNavbar(routes)}
          isOpen={isOpen}
          onClose={onClose}
          isChecked={fixed}
          onSwitch={(value) => {
            setFixed(value);
          }}
        /> */}
      </MainPanel>
    </Box>
  );
}